import React, { useState, useEffect } from "react";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import "moment/min/locales";
import "moment-timezone";
import { useTranslation } from "react-i18next";
import { InputLabel, makeStyles } from "@material-ui/core";
import styles from "../styles";
import { getDateFormat } from "../../../Utilities/Functions";

moment.locale("en");
moment.tz.setDefault("UTC");

const useStyles = makeStyles(styles);

const DateField = (props) => {
  const {
    id,
    label,
    labelIcon,
    name,
    placeholder,
    required,
    initialValue,
    disabled,
    onChange,
    minValue,
    maxValue,
  } = props;

  const { i18n, t } = useTranslation();

  useEffect(() => {
    setValue(
      initialValue && initialValue !== "" ? new Date(initialValue) : null,
    );
  }, [initialValue]);

  const [value, setValue] = useState(
    initialValue && initialValue !== "" ? new Date(initialValue) : null,
  );
  const classes = useStyles();

  const handleChange = (value) => {
    setValue(value);
    if (onChange !== undefined && typeof onChange === "function") {
      onChange(value);
    }
  };

  return (
    <MuiPickersUtilsProvider
      utils={MomentUtils}
      libInstance={moment}
      locale={i18n.language || "en"}
    >
      <InputLabel className={classes.inputLabel}>
        {label}
        {required && (
          <span
            aria-hidden="true"
            className="MuiFormLabel-asterisk MuiInputLabel-asterisk"
            style={{ color: "#E30613" }}
          >
            &thinsp;*
          </span>
        )}
        {labelIcon}
      </InputLabel>
      <KeyboardDatePicker
        name={name}
        id={id}
        size="small"
        margin="dense"
        format={getDateFormat()}
        clearable
        value={value}
        onChange={handleChange}
        inputVariant={"outlined"}
        placeholder={placeholder}
        inputVariant="outlined"
        minDate={minValue}
        maxDate={maxValue}
        //readOnly
        disabled={disabled}
        required={required}
        className={classes.inputField}
        fullWidth
        autoOk={true}
        okLabel={t("labels.common.ok")}
        cancelLabel={t("labels.common.cancel")}
        clearLabel={t("labels.common.clear")}
      />
    </MuiPickersUtilsProvider>
  );
};

export default DateField;
